import { now } from "./filters";
import { i18n } from "./i18n";
import store from "../store";
import CONSTANTS from "../config/constants";
import { getErrorMessage } from "./common";
const bizflyUI = require("bizfly-ui").default;

const {
  IAM_SERVICES,
  DISABLE_SERVICES_ACTION,
  DISABLE_REQUESTS_ACTION,
  ALLOW_SHOW_PERMISSION_DIALOG_WITH_GET_ENDPOINT,
} = CONSTANTS;

const { Notification } = bizflyUI;

export function handleResponseErrorMessage(err, isRedirect) {
  if (!err?.response) {
    return err;
  }

  store.log.state.errors.push(err);
  const currentPath = store?.services?.state?.currentService?.slug;
  const requestUrl = err?.response?.config?.url;
  let title = i18n.t("errors.title");
  let type = "error";

  let message = `${err?.response?.status}: ${
    getErrorMessage(err) ?? i18n.t("notification.anErrorOccurred")
  }`;

  switch (err?.response?.status) {
    case 401:
      if (!err?.response?.config?.url?.includes("github")) {
        const config = store?.endpoint?.state?.config;
        window.location.href = `${config.base.ssoUrl}/logout?service=${window.location.href}`;
      }
      break;

    case 403:
      break;

    case 404:
      break;

    case 417: // Cảnh báo của dịch vụ IAM
      title = i18n.t("notification.warning.title");
      type = "warning";
      break;

    case 422: // Cảnh báo của dịch vụ IAM
      break;

    case 500:
      message = i18n.t("errors.internalServer"); // 'Lỗi hệ thống!'
      break;

    case 502:
      message = i18n.t("errors.badGateway"); // 'Hệ thống đang bảo trì!'
      break;

    case 504:
      message = i18n.t("errors.gatewayTimeout"); // 'Không thể truy cập đến máy chủ!'

    default:
      break;
  }
  handleShowPermission({ currentPath, error: err });

  handleNotify({
    currentPath,
    requestUrl,
    message,
    type,
    title,
    error: err,
  });
  return err;
}

const handleNotify = ({
  currentPath,
  requestUrl,
  message,
  type,
  title,
  error,
}) => {
  if (
    !checkCondition({
      error,
      currentPath,
      requestUrl,
      status: error?.response?.status,
      method: error?.response?.config?.method,
      condition: "notify",
    })
  )
    return;
  Notification({ title, message, type, customClass: type });
};

const checkCondition = ({
  error,
  currentPath,
  requestUrl,
  status,
  method,
  condition,
}) => {
  const serviceConditions = DISABLE_SERVICES_ACTION?.[currentPath];
  const isIamResponse = error?.response?.data?.data?.details?.resource;
  const is403 = error?.response?.status === 403;
  if (!isIamResponse && is403) return true;
  if (serviceConditions?.length) {
    const currentServiceCondition = serviceConditions.find(
      (condition) =>
        ["all", status].includes(condition?.status) &&
        ["all", method].includes(condition?.method)
    );
    if (currentServiceCondition?.[condition] === false) return false;
  }
  const findKey = Object.keys(DISABLE_REQUESTS_ACTION).find((request) =>
    requestUrl.includes(request)
  );
  if (findKey) {
    const requestConditions = DISABLE_REQUESTS_ACTION?.[findKey];
    if (requestConditions?.length) {
      const currentRequestCondition = requestConditions.find(
        (condition) =>
          ["all", status].includes(condition?.status) &&
          ["all", method].includes(condition?.method)
      );
      if (currentRequestCondition?.[condition] === false) return false;
    }
  }
  return true;
};

const handleShowPermission = ({ currentPath, error }) => {
  const isIamService = IAM_SERVICES.find(
    (servicePath) => currentPath === servicePath
  );
  const is403 = error?.response?.status === 403;
  const isActionMethod = error?.response?.config?.method !== "get";
  const urlRequest = error?.response?.config?.url;
  const isIamResponse = error?.response?.data?.data?.details?.resource;
  const isAllowGetMethod = ALLOW_SHOW_PERMISSION_DIALOG_WITH_GET_ENDPOINT.find(
    (endpoint) =>
      urlRequest.includes(endpoint?.service) &&
      urlRequest.includes(endpoint?.endpoint)
  );
  if (
    isIamService &&
    is403 &&
    (isActionMethod || isAllowGetMethod) &&
    isIamResponse
  ) {
    store.permission.mutations.UPDATE_ERROR_PERMISSION(
      store.permission.state,
      error?.response?.data
    );
  }
};
